<template>
    <div>
        <div class="cstm-tab-holder">
            <div
                class="cstm-unique-tab flex mb-4"
            >
                <div style="width: calc(100% - 105px)" class="flex flex-wrap">
                    <div
                        class="tab-name"
                        :class="{ activeTab: template }"
                        @click="tab('template')"
                    >
                        Template
                    </div>
                    <div
                        class="tab-name"
                        :class="{ activeTab: report }"
                        @click="tab('report')"
                    >
                        Reports
                    </div>
                </div>
            </div>
            <div v-if="template">
              <Template />
            </div>

            <div v-if="report">
              <CourseWork />
            </div>
        </div>
    </div>
</template>

<script>
import Template from './Template/index.vue'
import CourseWork from './Report/index.vue'

export default {
  name: 'Report',
  components: {
    Template,
    CourseWork
  },
  data () {
    return {
      template: true,
      report: false      
    }
  },
  mounted() {
    this.tab(this.$route.hash.substring(1))
  },
  methods: {
    tab (type) {
      if (type === 'template') {
        this.template = true
        this.report = false
      } else if (type === 'report') {
        this.template = false
        this.report = true
      }
    }
  }
}
</script>